import { useTranslation } from 'react-i18next';
import { Box, Card, SxProps, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { LabelTag } from 'greener-ui-library';
import { SetupType, setupTypeTranslationKeys } from './utils';

interface MicrogridSetupBoxProps {
  imageSvg?: string;
  setupType?: SetupType;
  sx?: SxProps;
}

export const MicrogridSetupBox = ({ imageSvg, setupType, sx }: MicrogridSetupBoxProps) => {
  const { t } = useTranslation();
  const { palette } = useTheme();

  // If no data provided, don't render the component
  if (!imageSvg || !setupType) {
    return null;
  }

  return (
    <Card sx={{ p: 4, pb: 1, borderRadius: '8px', ...sx }}>
      <Box display="flex" flexDirection="column" gap={1}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3">{t('blueprints:details.microgridSetup.title')}</Typography>
          <LabelTag label={t(setupTypeTranslationKeys[setupType])} />
        </Box>

        <Box
          sx={{
            mt: palette.mode === 'dark' ? 1 : -1,
            mb: palette.mode === 'dark' ? 2 : 0,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bgcolor: palette.mode === 'dark' ? 'grey.300' : 'transparent',
            borderRadius: 2,
            p: palette.mode === 'dark' ? 2 : 0,
            '& svg': {
              width: '100%',
              height: 'auto',
              maxWidth: { xs: '400px', sm: '500px', md: '600px' },
            },
          }}
          dangerouslySetInnerHTML={{ __html: imageSvg }}
        />
      </Box>
    </Card>
  );
};
